import { styled, Typography } from '@mui/material';

export const StyledModalHeading = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.grey[600],
  letterSpacing: '-0.01em'
}));
